import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import { getShouldShowCopilotAutoReschedulingNotificationsCallout } from './selectors/copilotAutoReschedulingNotificationsStoreSelectors';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () =>
        import(/* webpackChunkName: "CopilotAutoReschedulingNotificationsCallout" */ './lazyIndex'),
    { name: 'CopilotAutoReschedulingNotificationsCallout' }
);

export const CopilotAutoReschedulingNotificationsCallout: LazyComponent<
    {}, // Use empty props as the component doesn't accept any props
    unknown,
    void
> = createLazyComponent(
    lazyModule,
    m => m.CopilotAutoReschedulingNotificationsCallout,
    undefined,
    undefined,
    {
        onlyImportIf: () => getShouldShowCopilotAutoReschedulingNotificationsCallout(),
    }
);

export const lazyShowCopilotAutoReschedulingNotificationsCallout: LazyAction<
    typeof lazyIndex.setShouldShowCopilotAutoReschedulingNotificationsCallout,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setShouldShowCopilotAutoReschedulingNotificationsCallout);
